/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import * as svgIcons from '@progress/kendo-svg-icons';
import { GridButton } from '../../appComponents/Styles';
import { borderGrey, phoneOnlyMaxWidth } from '../../appComponents/cssConstants';

const EditCommandCell =
	(onEdit?: (item: unknown) => void, onDelete?: (item: unknown) => void, onContactPage?: (item: unknown) => void) =>
	(props: GridCellProps) => {
		const { dataItem } = props;
		return (
			<td>
				{onEdit && (
					<EditButton title="Edit" svgIcon={svgIcons.pencilIcon} fillMode="flat" onClick={() => onEdit(dataItem)} />
				)}
				{onContactPage && (
					<BorderWrapper>
						<GridButton
							title="Contacts"
							svgIcon={svgIcons.userIcon}
							fillMode="flat"
							onClick={() => onContactPage(dataItem)}
						/>
					</BorderWrapper>
				)}
				{onDelete && (
					<BorderWrapper>
						<GridButton
							title="Delete"
							svgIcon={svgIcons.trashIcon}
							fillMode="flat"
							onClick={() => onDelete(dataItem)}
						/>
					</BorderWrapper>
				)}
			</td>
		);
	};

export default EditCommandCell;

const EditButton = styled(GridButton)`
	&:not(:last-child) {
		margin-right: 5px;

		@media (max-width: ${phoneOnlyMaxWidth}) {
			margin-right: 0;
		}
	}

	@media (max-width: ${phoneOnlyMaxWidth}) {
		display: block;
	}
`;

const BorderWrapper = styled.span`
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	vertical-align: middle;

	&:not(:first-child) {
		padding-left: 5px;

		&::before {
			content: '';
			height: 20px;
			border-left: 1px solid ${borderGrey};
			position: absolute;
			left: 0;
		}

		@media (max-width: ${phoneOnlyMaxWidth}) {
			padding-left: 0;

			&::before {
				display: none;
			}
		}
	}

	@media (max-width: ${phoneOnlyMaxWidth}) {
		display: block;
	}
`;
